module.exports = __webpack_public_path__ + "cross-white-6ab9fc1453f88d695840869dc4e63987.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/icons/cross-white.svg
// module id = 51
// module chunks = 0